import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { LinkedList } from 'vscode/vscode/vs/base/common/linkedList';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { CTX_INLINE_CHAT_HAS_PROVIDER } from 'vscode/vscode/vs/workbench/contrib/inlineChat/common/inlineChat';

let InlineChatServiceImpl = class InlineChatServiceImpl {
    constructor(contextKeyService) {
        this._onDidChangeProviders = ( new Emitter());
        this._entries = ( new LinkedList());
        this.onDidChangeProviders = this._onDidChangeProviders.event;
        this._ctxHasProvider = CTX_INLINE_CHAT_HAS_PROVIDER.bindTo(contextKeyService);
    }
    addProvider(provider) {
        const rm = this._entries.push(provider);
        this._ctxHasProvider.set(true);
        this._onDidChangeProviders.fire({ added: provider });
        return toDisposable(() => {
            rm();
            this._ctxHasProvider.set(this._entries.size > 0);
            this._onDidChangeProviders.fire({ removed: provider });
        });
    }
    getAllProvider() {
        return [...this._entries].reverse();
    }
};
InlineChatServiceImpl = ( __decorate([
    ( __param(0, IContextKeyService))
], InlineChatServiceImpl));

export { InlineChatServiceImpl };
